import { render, staticRenderFns } from "./ColorPicker.vue?vue&type=template&id=59739f54&scoped=true"
import script from "./ColorPicker.vue?vue&type=script&lang=js"
export * from "./ColorPicker.vue?vue&type=script&lang=js"
import style0 from "./ColorPicker.vue?vue&type=style&index=0&id=59739f54&prod&lang=scss&scoped=true"
import style1 from "vue-color-gradient-picker/dist/index.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59739f54",
  null
  
)

export default component.exports